var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRbNetworkProcs(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0H24V24H0z",
    transform: "translate(-114 -1391.001) translate(114 1391.001)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.191 5h8.794v1.956h-8.794zm0 5.379h8.794v1.956h-8.794zm0 5.379h8.794v1.956h-8.794zM2 11.357c0 3.5 3.21 6.357 7.145 6.357h.55v1.956l3.3-2.934-3.3-2.936v1.956h-.55a4.7 4.7 0 0 1-4.947-4.4 4.7 4.7 0 0 1 4.947-4.4h3.847V5H9.145C5.21 5 2 7.856 2 11.357z",
    transform: "translate(-114 -1391.001) translate(113 1391.001)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRbNetworkProcs);
export default __webpack_public_path__ + "static/media/rb-network-procs.c066e9299640919d39cd490cde1d1427.svg";
export { ForwardRef as ReactComponent };